import type React from 'react';
import { cn } from '@/lib/utils';
import { OrderStatusLabels, OrderStatusColors } from '@/types/enums';
import type { OrderStatus } from '@/types/enums';

interface BadgeProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info';
}

interface StatusBadgeProps {
  status: OrderStatus;
  className?: string;
}

const variantClasses = {
  default: 'bg-gray-100 text-gray-700',
  success: 'bg-emerald-100 text-emerald-700',
  warning: 'bg-amber-100 text-amber-700',
  error: 'bg-red-100 text-red-700',
  info: 'bg-blue-100 text-blue-700',
};

const Badge: React.FC<BadgeProps> & { Status: React.FC<StatusBadgeProps> } = ({
  children,
  className,
  variant = 'default',
}) => {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        variantClasses[variant],
        className,
      )}
    >
      {children}
    </span>
  );
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className }) => {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        OrderStatusColors[status],
        className,
      )}
    >
      {OrderStatusLabels[status]}
    </span>
  );
};

Badge.Status = StatusBadge;

export default Badge;
